import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
import NfseFiscalFields from '../components/NfseFiscalFields';
const empty = { nbs: '', indOp: '', cst: '', cClassTrib: '', issRate: '', simplesRate: '' };
export default function CompanyNfseTaxSettings() {
  const [values, setValues] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const edited = useRef(false);
  useEffect(() => {
    let active = true;
    api.get('/company/nfse-profile').then(response => {
      if (active && !edited.current) setValues(Object.fromEntries(Object.keys(empty).map(key => [key, response.data?.[key] ?? ''])));
    }).catch(() => { if (active) setError('Não foi possível consultar os padrões fiscais.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const save = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError(''); setMessage('');
    try {
      await api.put('/company/nfse-profile', values);
      setMessage('Padrões fiscais salvos.');
      window.dispatchEvent(new Event('nfse-settings-updated'));
    } catch (failure) { setError(failure?.response?.data?.error || 'Não foi possível salvar os padrões fiscais.'); }
    finally { setBusy(false); }
  };
  return <form onSubmit={save} className="space-y-4 rounded-xl border border-slate-200 bg-white p-5" aria-label="Padrões fiscais gerais">
    <h2 className="text-base font-semibold text-slate-900">Padrões fiscais gerais</h2>
    <NfseFiscalFields values={values} onChange={(key, value) => { edited.current = true; setValues(previous => ({ ...previous, [key]: value })); }} disabled={busy}/>
    {loading && <p role="status">Carregando...</p>}
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {message && <p role="status" className="text-sm text-slate-600">{message}</p>}
    <button type="submit" disabled={busy || loading} className="min-h-[44px] rounded-lg bg-blue-600 px-4 text-sm font-semibold text-white disabled:opacity-50">{busy ? 'Salvando...' : 'Salvar padrões'}</button>
  </form>;
}
